import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const FIELD = "w-full bg-transparent border-b border-[rgba(35,33,28,0.2)] py-3 text-[16px] text-[#23211c] placeholder:text-[#a49e90] focus:border-[#23211c] outline-none transition-colors font-light";
const LABEL = "font-label text-[10px] text-[#8b8578] mb-1 block";
const TRIGGER = "border-0 border-b border-[rgba(35,33,28,0.2)] rounded-none px-0 font-light text-[16px] focus:ring-0 h-auto py-3";

export const TextField = ({ id, label, value, onChange, type = "text", placeholder = "", className = "" }) => (
  <div className={className}>
    <label className={LABEL} htmlFor={id}>{label}</label>
    <input
      id={id}
      type={type}
      data-testid={`inquiry-${id}-input`}
      className={FIELD}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
    />
  </div>
);

export const TextArea = ({ id, label, value, onChange, placeholder = "", className = "" }) => (
  <div className={className}>
    <label className={LABEL} htmlFor={id}>{label}</label>
    <textarea
      id={id}
      rows={4}
      data-testid={`inquiry-${id}-input`}
      className={`${FIELD} resize-none`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
    />
  </div>
);

export const SelectField = ({ id, label, value, onChange, options, placeholder }) => (
  <div>
    <label className={LABEL}>{label}</label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={TRIGGER} data-testid={`inquiry-${id}-select`}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((opt) => (
          <SelectItem key={opt} value={opt}>{opt}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
